export default class DashboardModuleInfo {
  dataKey: string = ''
  name: string = ''
  key: string = ''
  entranceUrl: string = ''
  description: string = ''

  constructor(name: string, key: string, entranceUrl: string) {
    this.name = name
    this.key = key
    this.entranceUrl = entranceUrl
  }
}
